import { render } from "./App.vue?vue&type=template&id=f3eefbc8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f3eefbc8&lang=css"
script.render = render

export default script